import { useEffect, useState } from "react";
import { Chip } from "@mui/material";
import ModuleLayout from "../../components/enterprise/ModuleLayout";
import DataTable from "../../components/enterprise/DataTable";
import EmptyState from "../../components/dashboard/EmptyState";
import { systemTabsForRole } from "../navigation";
import { platformMockService } from "../../services/mock/platformMockService";
import { platformRealService } from "../../services/real/platformRealService";
import { useTranslation } from "react-i18next";
import { usePlatform } from "../../context/PlatformContext";

const CameraHealthPage = ({ role }) => {
  const { t } = useTranslation();
  const { showMockData } = usePlatform();
  const [rows, setRows] = useState([]);
  const [mode, setMode] = useState("real");

  useEffect(() => {
    if (showMockData) {
      setRows(platformMockService.getCameraHealth());
      setMode("mock");
      return undefined;
    }
    let alive = true;
    setRows([]);
    setMode("real");
    platformRealService.getCameraHealth()
      .then((realRows) => {
        if (!alive) return;
        setRows(realRows);
        setMode("real");
      })
      .catch(() => { if (alive) setMode("partial"); });
    return () => { alive = false; };
  }, [showMockData]);

  const columns = [
    { key: "name", header: t("platform.common.camera") },
    { key: "status", header: t("platform.common.status"), render: (row) => <Chip size="small" label={row.status} color={row.status === "online" ? "success" : row.status === "degraded" ? "warning" : row.status === "offline" ? "error" : "default"} /> },
    { key: "fps", header: "FPS" },
    { key: "latencyMs", header: t("platform.common.latency") },
    { key: "bitrate", header: "Bitrate" },
    { key: "droppedFrames", header: t("platform.common.dropped") },
    { key: "uptime", header: t("platform.common.uptime") },
    { key: "aiState", header: t("platform.common.aiState") },
  ];

  return (
    <ModuleLayout title={t("platform.pages.cameraHealth.title")} subtitle={t("platform.pages.cameraHealth.subtitle")} breadcrumbs={[t("platform.nav.system"), t("platform.pages.cameraHealth.title")]} tabs={systemTabsForRole(role)} dataMode={{ mode }}>
      {rows.length > 0 ? (
        <DataTable columns={columns} rows={rows} />
      ) : (
        <EmptyState title={mode === "partial" ? t("common.error") : t("common.noData")} description={t("platform.pages.cameraHealth.subtitle")} />
      )}
    </ModuleLayout>
  );
};

export default CameraHealthPage;
